import { createContext } from 'react';

export interface Parameters {
    [key: string]: any;

    custom_logo_height?: number;
    custom_logo_position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
    custom_logo_margin?: number;
    custom_logo_gap?: number;
    custom_logo_1_image_url?: string;
    custom_logo_1_popup_behavior?: 'hover' | 'click' | 'link' | 'disabled';
    custom_logo_1_popup_banner_image_url?: string;
    custom_logo_1_popup_title?: string;
    custom_logo_1_popup_description?: string;
    custom_logo_1_popup_link?: string;
    custom_logo_2_image_url?: string;
    custom_logo_2_popup_behavior?: 'hover' | 'click' | 'link' | 'disabled';
    custom_logo_2_popup_banner_image_url?: string;
    custom_logo_2_popup_title?: string;
    custom_logo_2_popup_description?: string;
    custom_logo_2_popup_link?: string;
    custom_logo_3_image_url?: string;
    custom_logo_3_popup_behavior?: 'hover' | 'click' | 'link' | 'disabled';
    custom_logo_3_popup_banner_image_url?: string;
    custom_logo_3_popup_title?: string;
    custom_logo_3_popup_description?: string;
    custom_logo_3_popup_link?: string;
}

const defaultParameters: Parameters = {
    custom_logo_height: 50,
    custom_logo_position: 'bottom-right',
    custom_logo_margin: 36,
    custom_logo_gap: 26
};

const ParameterContext = createContext<Parameters>(defaultParameters);

export default ParameterContext;
